export * from './inflation-hedge-hero'
